module.exports = __webpack_public_path__ + "media/svg/id-a869fd32.svg";